var MysaErrorsViewController = (function () {
    function MysaErrorsViewController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings, $mdDialog, filters) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$mdDialog = $mdDialog;
        this.filters = filters;
        this.newSearch = 'Default';
        this.someClickHandler = function (info) {
            _this.$state.go('admin.mysaerrlogs-details-view', {
                id: info.value
            });
        };
        this.rowCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function () {
                _this.$scope.$apply(function () {
                    _this.someClickHandler(aData);
                });
            });
            return nRow;
        };
        this.wasSapTriggered = false;
        this.showFilterBtn = false;
        this.rowData = {};
        this.dtInstance = {};
        this.tableData = {};
        this.filters = {};
        this.deferred = this.$q.defer();
    }
    MysaErrorsViewController.prototype.$onInit = function () {
        var _this = this;
        var that = this;
        this.dtColumns = this.buildColumns();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                that.tableData = data.data;
                return data.data;
            },
            url: '/api/admin/mysaerr-logs',
            type: 'POST',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', 'Bearer ' + _this.env.user.token);
            },
            data: function (d, callback, settings) {
                d.users = [("" + that.env.user.email)];
            },
            complete: function (d) {
                _this.wasSapTriggered = false;
            }
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('createdRow', createdRow)
            .withOption('rowCallback', this.rowCallback)
            .withPaginationType('full_numbers');
        function createdRow(row, data, dataIndex) {
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
        this.dtHistoryColumns = this.buildHistoryColumns();
        this.dtHistoryOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                that.tableData = data.data;
                return data.data;
            },
            url: '/api/admin/mysaerr-logs-history',
            type: 'POST',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', 'Bearer ' + _this.env.user.token);
            },
            data: function (d, callback, settings) {
                console.info(d, settings);
            },
            complete: function (d) {
                _this.wasSapTriggered = false;
            }
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('createdRow', createdHistoryRow)
            .withPaginationType('full_numbers');
        function createdHistoryRow(row, data, dataIndex) {
            var OFFSET = 3;
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
    };
    MysaErrorsViewController.prototype.buildColumns = function () {
        return [this.DTColumnBuilder.newColumn('value')
                .withTitle('OPP'),
        ];
    };
    MysaErrorsViewController.prototype.buildHistoryColumns = function () {
        return [
            this.DTColumnBuilder.newColumn('date')
                .withTitle('Time'),
            this.DTColumnBuilder.newColumn('data')
                .withTitle('Changes made'),
            this.DTColumnBuilder.newColumn('user')
                .withTitle('Changed by'),
        ];
    };
    MysaErrorsViewController.$inject = [
        '$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$mdDialog',
    ];
    return MysaErrorsViewController;
}());
var MysaErrorsComponent = (function () {
    function MysaErrorsComponent() {
        this.templateUrl = 'mysaerrlogs.html';
        this.controllerAs = 'vm';
        this.controller = MysaErrorsViewController;
    }
    return MysaErrorsComponent;
}());
angular
    .module('application')
    .component('mysaerrlogsSection', new MysaErrorsComponent());

//# sourceMappingURL=mysaerrlogs.component.js.map
